import React from 'react'
import { css } from '@linaria/core'

const timelineGridCss = css`
  display: grid;
  grid-row-gap: 4px;
  margin-top: 16px;
  max-width: 100%;
`

export default function TimelineGrid({ children, lowYear, highYear }) {
  const total = highYear - lowYear
  return (
    <div
      className={timelineGridCss}
      style={{ gridTemplateColumns: `repeat(${highYear - lowYear}, calc(100% / ${total}))` }}
    >
      {children}
    </div>
  )
}
